import React from 'react';

export const Progress = ({ progress }: { progress: number }) => {
  return (
    <div className="c-progress">
      <div className="c-progress__activeBar" style={{ width: progress + '%' }}/>
    </div>
  )
};